
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
// @ is an alias to /src
import axios, {AxiosResponse, AxiosError} from 'axios';
import HomeNewslistItem from './HomeNewslistItem.vue';
import $ from 'jquery';

@Component({
  components: {
    HomeNewslistItem,
  },
})
export default class HomeNewslist extends Vue {
  private name = 'homenewslist';
  private firstItemsLength = 3;
  private list: PostData[] = [];
  private offset: number = 0;
  private length: number|null = 3;
  private totaleItems: number = 0;
  private isOpend = false;
  get showMore() {
    if (this.totaleItems > this.firstItemsLength) {
      return true;
    } else {
      return false;
    }
  }
  @Emit()
  private setList(list: PostData[]) {
    this.list = list;
  }
  @Emit()
  private async getMoreItems() {
    // this.offset = this.firstItemsLength;
    if (this.length && this.length > 0) {
      this.length = null;
      await this.getEntries();
    }
    if (this.isOpend) {
      this.isOpend = false;
    } else {
      this.isOpend = true;
    }
    this.$nextTick(() => {
      if (!this.$refs.list) return;
      const $list: any = $(this.$refs.list);
      if (this.isOpend) {
        $list.find('.item:hidden').stop().slideDown();
      } else {
        $list.find('.item:gt(' + (this.firstItemsLength - 1) + ')').stop().slideUp();
      }
    });
  }
  @Emit()
  private async getEntries() {
    let api = `/api/wp-json/31corp/v1/posts?cat=info&offset=${this.offset}`;
    if (this.length) {
      api += `&length=${this.length}`;
    }
    const result = await axios({
      method: 'get',
      url: api,
      headers: { Authorization: 'Bearer ' + this.$store.getters['auth/token']},
    })
    .then( (response: AxiosResponse<ApiPost>) => {
      this.totaleItems = Number(response.data.hits);
      this.setList(response.data.datas);
      return true;
    })
    .catch( (e: AxiosError) => {
      console.log(e);
      return false;
    });
    return result;
  }
}
